import * as React from "react";

const ImportIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 431 431" {...props}>
		<path d="M214.8 321.35c-39.73-39.73-79.65-79.66-119.23-119.24 9.57-9.57 19.43-19.44 30.01-30.03 22.07 22.19 44.66 44.91 68 68.37V2.97h42.49v237.12c23.23-23.4 45.81-46.13 68.16-68.64 10.81 10.94 20.62 20.86 30.06 30.41-39.69 39.69-79.7 79.7-119.49 119.5Z" />
		<path d="M342.98 386.38v-84.77h42.49c.09 1.76.25 3.52.25 5.28.02 25.66.05 51.33 0 76.99-.06 27.37-18.05 45.35-45.46 45.37-83.48.04-166.96-.33-250.43.22-24.85.16-46.2-19.7-45.75-45.68.44-25.66.1-51.33.1-76.99v-5.23h42.63v84.81h256.17Z" />
	</svg>
);

export default ImportIcon;
